import React from 'react';
import HeroSection from './HeroSection';
import FeaturedContent from './FeaturedContent';
import NewsList from '../../components/features/NewsList';
import { Post, User } from '../../types';

// 模拟数据
const mockLatestPosts: Post[] = [
  {
    id: '1',
    title: '如何准备技术面试',
    content: '技术面试是进入科技公司的关键一步。本文将分享一些准备技术面试的技巧和经验...',
    author: {
      id: '1',
      uuid: 'user-1',
      name: '张明',
      email: 'zhangming@example.com',
      avatar: 'https://via.placeholder.com/40',
      bio: '资深软件工程师',
      createdAt: '2023-01-01',
      updatedAt: '2023-01-01'
    },
    category: 'article',
    tags: ['面试', '技术'],
    createdAt: '2023-01-01',
    updatedAt: '2023-01-01'
  },
  // 添加更多模拟文章...
];

const mockFeaturedUsers: User[] = [
  {
    id: '1',
    uuid: 'user-1',
    name: '李华',
    email: 'lihua@example.com',
    avatar: 'https://via.placeholder.com/64',
    bio: '前端开发工程师 | React专家',
    createdAt: '2023-01-01',
    updatedAt: '2023-01-01'
  },
  // 添加更多模拟用户...
];

const HomePage: React.FC = () => {
  return (
    <div>
      <HeroSection />
      <FeaturedContent
        latestPosts={mockLatestPosts}
        featuredUsers={mockFeaturedUsers}
      />
      <div className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-8">最近新闻</h2>
          <NewsList limit={6} />
        </div>
      </div>
    </div>
  );
};

export default HomePage;    